module.exports = __webpack_public_path__ + "static/media/Home_Purple.d974a5c3.png";